// PlayerComponent.js
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import axios from './../axios';
import { toast } from 'react-toastify';


const PlayerComponent = forwardRef(({
  videoId,
  handleBookmarkClick,
  handleTimeUpdate,
  setType,
  setBookmarks,
  setjumpToBookmark,
  handleUserLastSeen,
  clickedContent,
  contentProviderType
}, ref) => {
  const [otp, setOtp] = useState('');
  const [playbackInfo, setPlaybackInfo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentTime, setCurrentTime] = useState(0);
  const [youtubeVideoId, setYoutubeVideoId] = useState("");


  const vdoPlayer = useRef(null);



  const extractYouTubeVideoId = (iframeString) => {

    // Extract the `src` URL from the iframe
    const matchSrc = iframeString?.match(/src=["']([^"']+)["']/);
    if (!matchSrc) return null;

    const videoUrl = matchSrc[1]; // Extracted `src` URL

    // Extract the Video ID from YouTube Embed URL
    const matchId = videoUrl.match(/youtube\.com\/embed\/([^?]+)/);
    return matchId ? matchId[1] : null;
  };

  useEffect(() => {
    if (contentProviderType === "Weblink") {
      window.open(clickedContent.fileInfo.fileURL, "dikshTab");
    } else {
      const extractedId = extractYouTubeVideoId(clickedContent?.fileInfo?.fileURL);
      setYoutubeVideoId(extractedId);
    }
  }, [clickedContent]);

  const fetchVideoDetails = async () => {
    setLoading(true);
    if (videoId === null || videoId === undefined) {
      return;
    }
    try {
      const response = await axios.get(`/getVideoDetails/${videoId}`);
      const { otp, playbackInfo } = response.data;
      setOtp(otp);
      setPlaybackInfo(playbackInfo);
      setType('video');
    } catch (error) {
      console.error('Error fetching video details:', error);
      setError('Failed to load video details.');
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (videoId !== null) {
      fetchVideoDetails();
    }
  }, [videoId]);

  useEffect(() => {
    // Initialize the VdoCipher player when OTP and playbackInfo are available
    const iframe = document.querySelector('iframe');
    if (iframe) {
      const player = window.VdoPlayer.getInstance(iframe);
      vdoPlayer.current = player;

      player.video.addEventListener('play', () => {
      });

      player.api.getTotalPlayed().then((data) => {
      });

      const handleTimeUpdateEvent = () => {
        if (player.video) {
          handleTimeUpdate(player.video.currentTime); // Notify parent
        }
      };


      // Cleanup event listener
      return () => {
        localStorage.setItem("currenctTime", player.video.currentTime);
        handleUserLastSeen(player.video.currentTime);
        // player.video.removeEventListener('timeupdate', handleTimeUpdate);
      };
    }
  }, [otp, playbackInfo]);



  useImperativeHandle(ref, () => ({
    getCurrentTime: () => {
      if (vdoPlayer.current?.video) {
        vdoPlayer.current.video.pause();
        return vdoPlayer.current.video.currentTime;
      } else {
        console.log('Player not initialized.');
      }
    },
    pauseVideo: () => {
      if (vdoPlayer.current?.video) {
        vdoPlayer.current.video.pause();
      }
    },

    playVideo: () => {
      if (vdoPlayer.current?.video) {
        setTimeout(() => {
          vdoPlayer.current.video.play();
        }, 500);
      }
    },

    jumpToTime: (time) => {
      if (vdoPlayer.current && vdoPlayer.current.video) {
        vdoPlayer.current.video.currentTime = time;
      }
    }
  }));


  // const videoSrc = videoId
  //   ? `https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}&primaryColor=4245EF`
  //   : `https://www.youtube-nocookie.com/embed/${youtubeVideoId}?autoplay=1`;



  if (loading) <p style={{ padding: "5px", color: "#ffffff" }}>Loading...</p>;
  if (error) <p style={{ color: "#ffffff" }}>{error}</p>;
  if (videoId === null || videoId === undefined) {
    <p style={{ padding: "5px", color: "#ffffff" }}>No video data available.</p>
  };

  return (
    <>
      {/* {contentProviderType === "Weblink" ?
        <p style={{ color: "blue", padding: "5px", fontSize: "18px" }}>This content is playing in new tab!!</p> :
        <iframe
          src={videoSrc}
          frameBorder="0"
          id='iframe'
          allowFullScreen
          title="Video Player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          loading="lazy"
          ref={ref}
          style={{ width: '100%', height: '265px', position: 'relative' }}
        />
      } */}
      {videoId ? (
        otp && playbackInfo ? (
          <iframe
            src={`https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}&primaryColor=4245EF`}
            frameBorder="0"
            id="iframe"
            allowFullScreen
            title="Video Player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            loading="lazy"
            ref={ref}
            style={{ width: '100%', height: '265px', position: 'relative' }}
          />
        ) : (
          <p className='p-2'>Loading video...</p>
        )
      ) : contentProviderType === "Weblink" ? (<p style={{ color: "blue", padding: "5px", fontSize: "18px" }}>This content is playing in new tab!!</p>)
        : (
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${youtubeVideoId}?autoplay=1`}
            frameBorder="0"
            id="iframe"
            allowFullScreen
            title="YouTube Player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            loading="lazy"
            ref={ref}
            style={{ width: '100%', height: '265px', position: 'relative' }}
          />
        )}
    </>
  );
});

export default PlayerComponent;
